
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class SubmittedFormFilterService {

    constructor(
        private _http: HttpClient
    ) { }

    getInitialDataForSubmittedFilter() {
        return this._http.get(environment.serverUrl + '/tasks/getInitialDataForSubmittedFilter');
    }
}



// WEBPACK FOOTER //
// ./src/app/submitted-form-filter/submitted-form-filter.service.ts